module.exports = __webpack_public_path__ + "static/miba-73fafeeb8378b5d2747ba9ce38d35cfd.png";